import React from "react";
import "./calltoaction.css";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

function CallToAction() {
  return (
    <div className="cta main">
      <h1>Help in building skilled and productive communities by donating.</h1>
      <p>
        Donate and help us meet our objective, which is to establish or assist
        in the provision and promotion of feeding programs and or homes for
        abandoned children, youths, HIV/AIDS victims etc. by rental and or
        construction of homes, maintenance, and support of such programs.
      </p>
      <Button className="btn" variant="contained" color="primary">
        <Link to={"/donate"}>donate now</Link>
      </Button>
    </div>
  );
}

export default CallToAction;
